import { helpers, utils, query } from '@kurtosys/ksys-app-template';
import {
	IEntity,
	IQueryKeyValue,
} from '../../../models/commonTypes';
import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { IGridProps } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models';
import { IConfigurationRedirect } from '../../../models/app/IConfigurationRedirect';

/* [Component: appStoreComponentImport] */

const Query = query.Query;

export class AppStore extends AppStoreBase {
	url: URL;
	rawUrl: string;
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
		this.rawUrl = url;
		this.url = new URL(url);
	}

	@computed
	get hasData(): boolean {
		return true;
	}

	async customInitializeAfter() {
		const { searchStore, dropdownStore } = this.storeContext;
		// These should be async and the app component should not wait for them to load
		searchStore.initialize();
		dropdownStore.initialize();
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get gridProps(): IGridProps | undefined {
		const gridProps = this.appComponentConfiguration && this.appComponentConfiguration.gridProps;
		return gridProps;
	}

	@computed
	get redirectConfiguration(): IConfigurationRedirect | undefined {
		const { appStore } = this.storeContext;
		return appStore.configuration && appStore.configuration.redirect;
	}

	redirect(item: IEntity) {
		if (item) {
			const redirectHelper = new helpers.RedirectHelper(this.rawUrl);
			const redirectConfiguration = this.redirectConfiguration;
			if (redirectConfiguration) {
				const { queryStore } = this.storeContext;
				const { redirect, inputs: redirectInputs } = redirectConfiguration;
				const inputQueriesByKey = redirectInputs.reduce((redirectConfigInputs, inputConfig) => {
					if (!redirectConfigInputs[inputConfig.key]) {
						redirectConfigInputs[inputConfig.key] = inputConfig.query;
					}
					return redirectConfigInputs;
				}, {} as IQueryKeyValue);
				const { type } = item;
				const { context, ...existingExecutionOptions } = queryStore.executionOptions;
				const executionOptions = utils.object.deepMergeObjects(existingExecutionOptions, {
					context: {
						entityByType: {
							[type]: item,
						},
					},
				});
				const inputs = Query.convertQueryKeyValue(inputQueriesByKey || {}, executionOptions);
				redirectHelper.go(redirect, inputs);
			}
		}
	}

	overrideEntityContext(entity: IEntity) {
		return { context: { entityByType: { [entity.type]: entity } } };
	}

}